<template>
    <div class="c_connect_shopItem">
        <div class="carOrderItem-room" >
            <div class="carOrderItem-room-checkbox">
                <div class="carOrderItem-room-icon js-carOrderItemRoomIcon" :class="{ active: isSelected}"
                @click="onConnectRoomSelected(connectId, firstStateroom.cruiseId)">
                    <img src="https://resource.rcclchina.com.cn/tui2/packageGuestInfo/icon10.png">
                </div>
            </div>
            <div class="carOrderItem-room-m">
                <div class="carOrderItem-room-img js-carOrderItemRoomIcon">
                    <img :src="getStateroomImage(firstStateroom)">
                </div>
                <div class="carOrderItem-room-box">
                    <a class="c_delete_btn">删除2间</a>
                    <div class="carOrderItem-room-box-delete c_box_delete" @click="onDeleteConnectRoom(connectId)">
                        <img src="https://resource.rcclchina.com.cn/tui2/packageGuestInfo/icon12.png">
                    </div>
                    <div class="carOrderItem-room-box-name">{{getStateroomName(firstStateroom)}}</div>
                    <div class="carOrderItem-room-box-info">
                      <span>{{ getStateroom(firstStateroom).areaInfo }}</span
                      ><span>{{ getStateroomBalcony(firstStateroom) }}</span
                      ><span>{{ getStateroomFloorInfo(firstStateroom) }}</span>
                    </div>
                    <template v-if="firstStateroom.stateroomType === 'DELUXE'">
<!--                      <DeviceFeatureTags is-detail is-detail-txt-cart :tags="firstStateroom.featureDeviceTags" :view-num="2"-->
<!--                                          @submit="onStateroomClicked($event, firstStateroom)"></DeviceFeatureTags>-->
                      <DeviceFeatureTags is-detail is-detail-txt-cart :view-num="2"
                                         @submit="onStateroomClicked($event, firstStateroom)"></DeviceFeatureTags>
                    </template>
                    <template v-else>
<!--                      <DeviceFeatureTags is-detail is-detail-txt-cart :tags="firstStateroom.featureDeviceTags"-->
<!--                                          @submit="onStateroomClicked($event, firstStateroom)"></DeviceFeatureTags>-->
                      <DeviceFeatureTags is-detail is-detail-txt-cart
                                         @submit="onStateroomClicked($event, firstStateroom)"></DeviceFeatureTags>
                    </template>
                    <div v-if="firstStateroom.groupType === 'QIAOHU'">
                      <img class="QIAOHU_CSS" @click="showQiaohuPopup" src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                    </div>
                    <div v-else-if="firstStateroom.groupType === 'STARRYSKY'">
                      <img class="STARRYSKY_CSS" @click="showStarrySkyPopup" src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                    </div>
                    <div v-else-if="firstStateroom.groupType === 'PCPGIFT'">
                      <img class="PCP_GIFT_THEME_CSS" @click="showCustomThemePopup(firstPersonalizedStateroomInfo)"
                           :src="firstPersonalizedStateroomInfo?.roomIconImage">
                    </div>
                    <div v-else-if="firstStateroom.groupType === 'CUSTOM'">
                      <img class="CUSTOM_THEME_CSS" @click="showCustomThemePopup(firstPersonalizedStateroomInfo)"
                           :src="firstPersonalizedStateroomInfo?.roomIconImage">
                    </div>
                    <img class="c_mb_shop"
                        style="width: 97px;margin-top: 5px" @click="showConnectRoomPopup"
                        src="https://resource.rcclchina.com.cn/cruiseDetail/mb_con_roompic.png">
                    <div class="carOrderItem-room-box-txt2">
                        <div class="carOrderItem-room-box-price">
                            <div class="carOrderItem-room-box-price-txt3">{{firstStateroom.isnrp ? '早订特惠价': '优惠价'}}(含税)：</div>
                            <div class="carOrderItem-room-box-price-txt1">¥</div>
                            <div class="carOrderItem-room-box-price-txt2">{{firstStateroom.netAmount > 0 ? firstStateroom.netAmount.toFixed(0): ''}}</div>
                            <div class="carOrderItem-room-box-price-txt3">/人起</div>
                        </div>
                    </div>
                    <div v-if="firstStateroom.amountPerNight" class="desc_per_night">平均每晚￥{{firstStateroom.amountPerNight}}/人起</div>
                    <div class="carOrderItem-room-box-txt2 carOrderItem-room-box-btns">
                        <div class="carOrderItem-room-box-nrpType unsubscribeOpenBtn ">
                            {{getNrpTitle(firstStateroom)}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="carOrderItem-room">
            <div class="carOrderItem-room-m">
                <div class="carOrderItem-room-img js-carOrderItemRoomIcon">
                    <img :src="getStateroomImage(secondStateroom)"></div>
                <div class="carOrderItem-room-box">
                    <div class="carOrderItem-room-box-name">{{getStateroomName(secondStateroom)}}</div>
                    <div class="carOrderItem-room-box-info">
                        <span>{{ getStateroom(secondStateroom).areaInfo }}</span
                          ><span>{{ getStateroomBalcony(secondStateroom) }}</span
                          ><span>{{ getStateroomFloorInfo(secondStateroom) }}</span>
                    </div>
                    <template v-if="secondStateroom.stateroomType === 'DELUXE'">
<!--                      <DeviceFeatureTags is-detail is-detail-txt-cart :tags="secondStateroom.featureDeviceTags" :view-num="2"-->
<!--                                          @submit="onStateroomClicked($event, secondStateroom)"></DeviceFeatureTags>-->
                      <DeviceFeatureTags is-detail is-detail-txt-cart :view-num="2" @submit="onStateroomClicked($event, secondStateroom)"></DeviceFeatureTags>
                    </template>
                    <template v-else>
<!--                      <DeviceFeatureTags is-detail is-detail-txt-cart :tags="secondStateroom.featureDeviceTags"-->
<!--                                          @submit="onStateroomClicked($event, secondStateroom)"></DeviceFeatureTags>-->
                      <DeviceFeatureTags is-detail is-detail-txt-cart @submit="onStateroomClicked($event, secondStateroom)"></DeviceFeatureTags>
                    </template>
                  <div v-if="secondStateroom.groupType === 'QIAOHU'">
                    <img class="QIAOHU_CSS" @click="showQiaohuPopup" src="https://resource.rcclchina.com.cn/QIAOHU/Mobile_QIAOHU.jpg">
                  </div>
                  <div v-else-if="secondStateroom.groupType === 'STARRYSKY'">
                    <img class="STARRYSKY_CSS" @click="showStarrySkyPopup" src="https://resource.rcclchina.com.cn/STARRYSKY/MB_icon.png">
                  </div>
                  <div v-else-if="secondStateroom.groupType === 'PCPGIFT'">
                    <img class="PCP_GIFT_THEME_CSS" @click="showCustomThemePopup(secondPersonalizedStateroomInfo)"
                         :src="secondPersonalizedStateroomInfo?.roomIconImage">
                  </div>
                  <div v-else-if="secondStateroom.groupType === 'CUSTOM'">
                    <img class="CUSTOM_THEME_CSS" @click="showCustomThemePopup(secondPersonalizedStateroomInfo)"
                         :src="secondPersonalizedStateroomInfo?.roomIconImage">
                  </div>
                    <img class="c_mb_shop" style="width: 97px;margin-top: 5px"
                        src="https://resource.rcclchina.com.cn/cruiseDetail/mb_con_roompic.png">
                    <div class="carOrderItem-room-box-txt2">
                        <div class="carOrderItem-room-box-price">
                            <div class="carOrderItem-room-box-price-txt3">{{secondStateroom.isnrp ? '早订特惠价': '优惠价'}}(含税)：</div>
                            <div class="carOrderItem-room-box-price-txt1">¥</div>
                            <div class="carOrderItem-room-box-price-txt2">{{secondStateroom.netAmount > 0 ? secondStateroom.netAmount.toFixed(0): ''}}</div>
                            <div class="carOrderItem-room-box-price-txt3">/人起</div>
                        </div>
                    </div>
                    <div v-if="secondStateroom.amountPerNight" class="desc_per_night">平均每晚￥{{secondStateroom.amountPerNight}}/人起</div>
                    <div class="carOrderItem-room-box-txt2 carOrderItem-room-box-btns">
                        <div class="carOrderItem-room-box-nrpType unsubscribeOpenBtn freeactive">
                            {{getNrpTitle(secondStateroom)}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import nrpConfig from '@/utilities/nrpConfig'
const DeviceFeatureTags = ()=> import("@/components/Cruise/DeviceFeatureTags");
export default {
    name: "ShoppingCartConnectRoom",
    components: {
      DeviceFeatureTags
    },
    props: {
        shoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        selectedShoppingCarts: {
            type: Array,
            default () {
                return []
            }
        },
        onConnectRoomSelected: {
            type: Function
        },
        onDeleteConnectRoom: {
            type: Function
        },
        showConnectRoomPopup: {
            type: Function
        },
        showQiaohuPopup: {
          type: Function
        },
        showStarrySkyPopup: {
          type: Function
        },
        showCustomThemePopup: {
            type: Function
        }
    },
    methods: {
        getStateroom (shoppingCart) {
            if (!shoppingCart.stateroomPartRecord) {
                return {}
            }
            return shoppingCart.stateroomPartRecord
        },
        getStateroomName (shoppingCart) {
            const stateroom = this.getStateroom(shoppingCart)
            if (!stateroom.stateroomCategoryCode) return ''
            let name = stateroom.cnName
            let code = stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            return `${name}_${code}`
        },
        getStateroomBalcony (shoppingCart) {
            const stateroom = this.getStateroom(shoppingCart)
            const balcony = stateroom.balconyAreaInfo
            if (!balcony || balcony == '' || balcony == '无') {
                return '无阳台'
            }
            return balcony
        },
        getStateroomImage (shoppingCart) {
            const stateroom = this.getStateroom(shoppingCart)
            return stateroom.desImage
        },
        getStateroomFloorInfo (shoppingCart) {
          const stateroom = this.getStateroom(shoppingCart)
          return stateroom.floorInfo
        },
        getNrpTitle(stateroom) {
            if (stateroom.isFortyEightHoursNrpCruise) {
                return nrpConfig.fortyEightHoursNrp.title
            } else if (stateroom.isnrp) {
                return nrpConfig.nrp.title
            }
            return nrpConfig.rp.title
        },
        getNrpText(stateroom) {
          if (stateroom.isFortyEightHoursNrpCruise) {
            return nrpConfig.fortyEightHoursNrp.description
          } else if (stateroom.isnrp) {
            return nrpConfig.nrp.description
          }
          return nrpConfig.rp.description
        },
        getPriceType(stateroom) {
          if (stateroom.isFortyEightHoursNrpCruise) {
            return nrpConfig.fortyEightHoursNrp.priceType;
          } else if (stateroom.isnrp) {
            return nrpConfig.nrp.priceType;
          }
          return nrpConfig.rp.priceType;
        },
        onStateroomClicked(e, stateroom) {
          e.stopPropagation();
          // let shoppingCart = this.shoppingCarts[stateroomIndex];
          let stateroomPartRecord = this.getStateroom(stateroom);
          console.log(stateroom)
          const stateroomData = {
            stateroomImages: stateroomPartRecord.stateroomImages || null,
            stateroomName: stateroomPartRecord.cnName,
            stateroomCategory: stateroom.berthedCategoryCode,
            stateroomPriceType: this.getPriceType(stateroom),
            stateroomPrice: stateroom.netAmount,
            stateroomCapacity: stateroomPartRecord.capacity,
            stateroomArea: stateroomPartRecord.areaInfo,
            stateroomBalcony: stateroomPartRecord.balconyAreaInfo,
            stateroomFloor: stateroomPartRecord.floorInfo,
            suiteType: stateroomPartRecord.suiteType,
            stateroomType: stateroom.stateroomType,
            isQiaohu: stateroom.groupType == 'QIAOHU',
            isStarrySky: stateroom.groupType == 'STARRYSKY',
            stateroomDescription: stateroom.description,
            stateroomNrpTitle: this.getNrpTitle(stateroom),
            stateroomNrpText: this.getNrpText(stateroom),
            personalizedStateroomInfo: stateroomPartRecord.personalizedStateroomInfo,
            // deviceFeatureTags: stateroom.featureDeviceTags,
            // deviceGroupTags: stateroom.deviceTags
            deviceGroupTags: stateroom.deviceTags,
            stateroomImageDataList: stateroom.stateroomImageDataList,
            roomSummaryList: stateroom.roomSummaryList || [],
            suiteRightsCount: stateroom.suiteRightsCount
          };
          console.log(stateroomData)
          this.$emit('detail', stateroomData);
        }
    },
    computed: {
        firstStateroom () {
            if (this.shoppingCarts.length < 2) {
                return {}
            }
            return this.shoppingCarts[0]
        },
        secondStateroom () {
            if (this.shoppingCarts.length < 2) {
                return {}
            }
            return this.shoppingCarts[1]
        },
        isSelected () {
            return this.selectedShoppingCarts.length > 0
        },
        connectId () {
            return this.firstStateroom.connectId
        },
        firstPersonalizedStateroomInfo() {
          return this.firstStateroom.bookingShoppingCart.stateroomPartViewModel.personalizedStateroomInfo;
        },
        secondPersonalizedStateroomInfo() {
          return this.secondStateroom.bookingShoppingCart.stateroomPartViewModel.personalizedStateroomInfo;
        }
    }
}
</script>

<style lang="less" scoped>
img {
    max-width: 100%;
}
.c_connect_shopItem {
    background-color: #FFF7CD;
    border-top: 2px solid #F8DE57;
    border-bottom: 2px solid #F8DE57;
    margin-left: -20px;
    margin-right: -20px;
    .carOrderItem-room {
        display: -webkit-box;
        display: -webkit-flex;
        display: -moz-box;
        display: -ms-flexbox;
        display: flex;
        padding: 15px 0 14px;
        border-bottom: none;
        margin-left: 20px;
        .carOrderItem-room-checkbox {
            position: relative;
            width: 40px;
            margin-left: -20px;
            padding-left: 20px;
            .carOrderItem-room-icon {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                display: -webkit-box;
                display: -webkit-flex;
                display: -moz-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: center;
                -webkit-justify-content: center;
                -moz-box-pack: center;
                -ms-flex-pack: center;
                justify-content: center;
                -webkit-box-align: center;
                -webkit-align-items: center;
                -moz-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                width: 15px;
                height: 15px;
                margin-right: 5px;
                margin-top: 3px;
                border: 1px solid #4A90E2;
                border-radius: 100%;
                img {
                    display: none;
                    width: 12px;
                }
            }

            .carOrderItem-room-icon.active {
                background-color: #4A90E2;
                img {
                    display: block;
                }
            }

        }
        .carOrderItem-room-m {
            -webkit-box-flex: 1;
            -webkit-flex: 1;
            -moz-box-flex: 1;
            -ms-flex: 1;
            flex: 1;
            display: -webkit-box;
            display: -webkit-flex;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            .carOrderItem-room-img {
                -webkit-box-flex: 0;
                -webkit-flex: none;
                -moz-box-flex: 0;
                -ms-flex: none;
                flex: none;
                width: 100px;
                margin-right: 10px;
            }
            .carOrderItem-room-box {
                -webkit-box-flex: 1;
                -webkit-flex: 1;
                -moz-box-flex: 1;
                -ms-flex: 1;
                flex: 1;
                position: relative;
                .c_delete_btn {
                    display: block;
                    font-weight: 400;
                    color: #747d80;
                    position: absolute;
                    right: 15px;
                    top: 19px;
                    font-size: 12px;
                }
                .carOrderItem-room-box-delete {
                    position: absolute;
                    top: 0px;
                    right: 15px;
                    z-index: 2;
                    width: 30px;
                    height: 30px;
                    padding-left: 15px;
                    padding-bottom: 15px;
                }
                .carOrderItem-room-box-name {
                    padding-right: 30px;
                    padding-bottom: 3px;
                    font-size: 14px;
                    line-height: 20px;
                    color: #333;
                    font-weight: bold;
                }
                .carOrderItem-room-box-info {
                  padding-bottom: 0;
                  font-size: 12px;
                  line-height: 12px;
                  color: #666;
                  letter-spacing: -1px;
                  span {
                    display: inline-block;
                  }
                  span + span {
                    margin-left: 7px;
                    padding-left: 7px;
                    border-left: 1px solid #979797;
                  }
                }
                .c_mb_shop {
                    width: 97px;
                }
                .carOrderItem-room-box-txt2 {
                    margin-top: -2px;
                }
                .carOrderItem-room-box-price {
                    margin-top: 6px;
                    -webkit-box-flex: 1;
                    -webkit-flex: 1;
                    -moz-box-flex: 1;
                    -ms-flex: 1;
                    flex: 1;
                    display: -webkit-box;
                    display: -webkit-flex;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-align: center;
                    -webkit-align-items: center;
                    -moz-box-align: center;
                    -ms-flex-align: center;
                    align-items: center;
                    .carOrderItem-room-box-price-txt3 {
                        font-size: 10px;
                        line-height: 1;
                        color: #666;
                    }
                    .carOrderItem-room-box-price-txt1 {
                        font-size: 12px;
                        line-height: 1;
                        color: #FF5055;
                    }
                    .carOrderItem-room-box-price-txt2 {
                        margin-right: 3px;
                        font-size: 18px;
                        line-height: 1;
                        color: #FF5055;
                        font-weight: bold;
                    }
                }
                .carOrderItem-room-box-btns {
                    margin-top: 3px;
                    overflow: hidden;
                    .carOrderItem-room-box-nrpType {
                        float: left;
                        background: #FEBC10;
                        border-radius: 4px;
                        color: white;
                        font-size: 11px;
                        padding: 0 9px;
                        display: inline-block;
                    }
                }
            }
        }
    }
    .carOrderItem-room:first-child {
        padding-bottom: 14px;
    }

    .carOrderItem-room:last-child {
        margin-left: 40px;
        padding-top: 0;
    }
    & .desc_per_night {
      line-height: 18px;
      letter-spacing: -1px;
      font-size: 12px;
      margin-top: 1px;
      color: #a6aeb1;
    }

    .QIAOHU_CSS {
      display: block;
      height: 18px;
      margin-top: 5px;
    }

    .STARRYSKY_CSS {
      display: block;
      height: 18px;
      margin-top: 5px;
    }
    .PCP_GIFT_THEME_CSS {
      display: block;
      height: 23px;
      margin-top: 5px;
    }
    .CUSTOM_THEME_CSS {
      display: block;
      height: 18px;
      margin-top: 5px;
    }
}
</style>
